<template>
  <article class="generic_form">
    <div class="generic_form__section">
      <v-checkbox
      v-model="events.tickets"
      ></v-checkbox>
      <div class="generic_form__section--text">
        <p class="generic_form__section--title">Boletería</p>
      </div>
    </div>
  </article>
</template>

<script>
export default {
  data(){
    return{
      events:{
        tickets: false
      }
    }
  },
  mounted(){
    this.events = this.getCompanyEvents()
  },
  beforeDestroy(){
    this.updateCompanyEvents(this.events)
    this.updateValidationEvents(this.events.tickets)
    console.log(this.getCompanyEvents());
  }
}
</script>

<style lang="css">
</style>
